import SingleAudioPlayer_EPlayerFramedPlayComponent from '@wix/thunderbolt-elements/src/components/SingleAudioPlayer/viewer/skinComps/EPlayerFramedPlay/EPlayerFramedPlay.skin';


const SingleAudioPlayer_EPlayerFramedPlay = {
  component: SingleAudioPlayer_EPlayerFramedPlayComponent
};


export const components = {
  ['SingleAudioPlayer_EPlayerFramedPlay']: SingleAudioPlayer_EPlayerFramedPlay
};

